import * as yup from "yup";

const SINCH_SERVICE_ID_RE = /^[A-Za-z0-9_-]+$/;
const E164_RE = /^\+[1-9]\d{1,14}$/;

export interface UpsertFaxProfileFormData {
  sinchServiceId: string;
  faxNumber: string;
}

export const upsertFaxProfileSchema: yup.ObjectSchema<UpsertFaxProfileFormData> =
  yup.object({
    sinchServiceId: yup
      .string()
      .required("Sinch Service ID is required")
      .matches(SINCH_SERVICE_ID_RE, "Letters, digits, underscore, hyphen only")
      .max(128, "Max 128 characters"),
    faxNumber: yup
      .string()
      .required("Fax number is required")
      .matches(E164_RE, "Must be E.164 format, e.g. +15612600684"),
  });
